module.exports = __webpack_public_path__ + "static/media/bm-ortofoto2017.f80b7f23.png";